import { z } from 'zod';

/**
 * POST /api/projects/:projectId/move-to-team (Idempotency-Key honoured) — move one of
 * MY Personal projects (never the Inbox) into a regular team where I may
 * `project.create`.  A real move: ids stay, so links, files and comments keep working;
 * the project becomes visible to the team.  Repeating the call after success is a
 * no-op that answers the same shape with `moved: false`.
 */
export const MoveProjectToTeamSchema = z.object({ targetTeamId: z.string().uuid() }).strict();
export type MoveProjectToTeamInput = z.infer<typeof MoveProjectToTeamSchema>;

export const MoveProjectToTeamResultSchema = z.object({
  projectId: z.string().uuid(),
  teamId: z.string().uuid(),
  teamSlug: z.string(),
  projectSlug: z.string(),
  projectKey: z.string(),
  /** False when the project already lived in the target team (idempotent replay). */
  moved: z.boolean(),
  /** The key / slug had to change because the team already used them. */
  keyChanged: z.boolean(),
  slugChanged: z.boolean(),
  /** How many tasks now live in the team (archived ones included). */
  taskCount: z.number().int().nonnegative(),
});
export type MoveProjectToTeamResult = z.infer<typeof MoveProjectToTeamResultSchema>;
